export const stateOptionsCanada = [
  { value: 'AB', label: { id: 'stateOptionsCanada.AB', defaultMessage: 'AB' } },
  { value: 'BC', label: { id: 'stateOptionsCanada.BC', defaultMessage: 'BC' } },
  { value: 'MB', label: { id: 'stateOptionsCanada.MB', defaultMessage: 'MB' } },
  { value: 'NB', label: { id: 'stateOptionsCanada.NB', defaultMessage: 'NB' } },
  { value: 'NL', label: { id: 'stateOptionsCanada.NL', defaultMessage: 'NL' } },
  { value: 'NS', label: { id: 'stateOptionsCanada.NS', defaultMessage: 'NS' } },
  { value: 'NT', label: { id: 'stateOptionsCanada.NT', defaultMessage: 'NT' } },
  { value: 'NU', label: { id: 'stateOptionsCanada.NU', defaultMessage: 'NU' } },
  { value: 'ON', label: { id: 'stateOptionsCanada.ON', defaultMessage: 'ON' } },
  { value: 'PE', label: { id: 'stateOptionsCanada.PE', defaultMessage: 'PE' } },
  { value: 'QC', label: { id: 'stateOptionsCanada.QC', defaultMessage: 'QC' } },
  { value: 'SK', label: { id: 'stateOptionsCanada.SK', defaultMessage: 'SK' } },
  { value: 'YT', label: { id: 'stateOptionsCanada.YT', defaultMessage: 'YT' } },
];

export const stateOptionsUS = [
  { value: 'AL', label: { id: 'stateOptionsUS.alabama', defaultMessage: 'Alabama' } },
  { value: 'AK', label: { id: 'stateOptionsUS.alaska', defaultMessage: 'Alaska' } },
  { value: 'AZ', label: { id: 'stateOptionsUS.arizona', defaultMessage: 'Arizona' } },
  { value: 'AR', label: { id: 'stateOptionsUS.arkansas', defaultMessage: 'Arkansas' } },
  { value: 'CA', label: { id: 'stateOptionsUS.california', defaultMessage: 'California' } },
  { value: 'CO', label: { id: 'stateOptionsUS.colorado', defaultMessage: 'Colorado' } },
  { value: 'CT', label: { id: 'stateOptionsUS.connecticut', defaultMessage: 'Connecticut' } },
  { value: 'DE', label: { id: 'stateOptionsUS.delaware', defaultMessage: 'Delaware' } },
  { value: 'FL', label: { id: 'stateOptionsUS.florida', defaultMessage: 'Florida' } },
  { value: 'GA', label: { id: 'stateOptionsUS.georgia', defaultMessage: 'Georgia' } },
  { value: 'HI', label: { id: 'stateOptionsUS.hawaii', defaultMessage: 'Hawaii' } },
  { value: 'ID', label: { id: 'stateOptionsUS.idaho', defaultMessage: 'Idaho' } },
  { value: 'IL', label: { id: 'stateOptionsUS.illinois', defaultMessage: 'Illinois' } },
  { value: 'IN', label: { id: 'stateOptionsUS.indiana', defaultMessage: 'Indiana' } },
  { value: 'IA', label: { id: 'stateOptionsUS.iowa', defaultMessage: 'Iowa' } },
  { value: 'KS', label: { id: 'stateOptionsUS.kansas', defaultMessage: 'Kansas' } },
  { value: 'KY', label: { id: 'stateOptionsUS.kentucky', defaultMessage: 'Kentucky' } },
  { value: 'LA', label: { id: 'stateOptionsUS.louisiana', defaultMessage: 'Louisiana' } },
  { value: 'ME', label: { id: 'stateOptionsUS.maine', defaultMessage: 'Maine' } },
  { value: 'MD', label: { id: 'stateOptionsUS.maryland', defaultMessage: 'Maryland' } },
  { value: 'MA', label: { id: 'stateOptionsUS.massachusetts', defaultMessage: 'Massachusetts' } },
  { value: 'MI', label: { id: 'stateOptionsUS.michigan', defaultMessage: 'Michigan' } },
  { value: 'MN', label: { id: 'stateOptionsUS.minnesota', defaultMessage: 'Minnesota' } },
  { value: 'MS', label: { id: 'stateOptionsUS.mississippi', defaultMessage: 'Mississippi' } },
  { value: 'MO', label: { id: 'stateOptionsUS.missouri', defaultMessage: 'Missouri' } },
  { value: 'MT', label: { id: 'stateOptionsUS.montana', defaultMessage: 'Montana' } },
  { value: 'NE', label: { id: 'stateOptionsUS.nebraska', defaultMessage: 'Nebraska' } },
  { value: 'NV', label: { id: 'stateOptionsUS.nevada', defaultMessage: 'Nevada' } },
  { value: 'NH', label: { id: 'stateOptionsUS.newHampshire', defaultMessage: 'New Hampshire' } },
  { value: 'NJ', label: { id: 'stateOptionsUS.newJersey', defaultMessage: 'New Jersey' } },
  { value: 'NM', label: { id: 'stateOptionsUS.newMexico', defaultMessage: 'New Mexico' } },
  { value: 'NY', label: { id: 'stateOptionsUS.newYork', defaultMessage: 'New York' } },
  { value: 'NC', label: { id: 'stateOptionsUS.northCarolina', defaultMessage: 'North Carolina' } },
  { value: 'ND', label: { id: 'stateOptionsUS.northDakota', defaultMessage: 'North Dakota' } },
  { value: 'OH', label: { id: 'stateOptionsUS.ohio', defaultMessage: 'Ohio' } },
  { value: 'OK', label: { id: 'stateOptionsUS.oklahoma', defaultMessage: 'Oklahoma' } },
  { value: 'OR', label: { id: 'stateOptionsUS.oregon', defaultMessage: 'Oregon' } },
  { value: 'PA', label: { id: 'stateOptionsUS.pennsylvania', defaultMessage: 'Pennsylvania' } },
  { value: 'RI', label: { id: 'stateOptionsUS.rhodeIsland', defaultMessage: 'Rhode Island' } },
  { value: 'SC', label: { id: 'stateOptionsUS.southCarolina', defaultMessage: 'South Carolina' } },
  { value: 'SD', label: { id: 'stateOptionsUS.southDakota', defaultMessage: 'South Dakota' } },
  { value: 'TN', label: { id: 'stateOptionsUS.tennessee', defaultMessage: 'Tennessee' } },
  { value: 'TX', label: { id: 'stateOptionsUS.texas', defaultMessage: 'Texas' } },
  { value: 'UT', label: { id: 'stateOptionsUS.utah', defaultMessage: 'Utah' } },
  { value: 'VT', label: { id: 'stateOptionsUS.vermont', defaultMessage: 'Vermont' } },
  { value: 'VA', label: { id: 'stateOptionsUS.virginia', defaultMessage: 'Virginia' } },
  { value: 'WA', label: { id: 'stateOptionsUS.washington', defaultMessage: 'Washington' } },
  { value: 'WV', label: { id: 'stateOptionsUS.westVirginia', defaultMessage: 'West Virginia' } },
  { value: 'WI', label: { id: 'stateOptionsUS.wisconsin', defaultMessage: 'Wisconsin' } },
  { value: 'WY', label: { id: 'stateOptionsUS.wyoming', defaultMessage: 'Wyoming' } },
];

export const stateOptionsAustralia = [
  { value: 'NSW', label: { id: 'stateOptionsAustralia.AB', defaultMessage: 'NSW' } },
  { value: 'QLD', label: { id: 'stateOptionsAustralia.QLD', defaultMessage: 'QLD' } },
  { value: 'SA', label: { id: 'stateOptionsAustralia.SA', defaultMessage: 'SA' } },
  { value: 'TAS', label: { id: 'stateOptionsAustralia.TAS', defaultMessage: 'TAS' } },
  { value: 'VIC', label: { id: 'stateOptionsAustralia.VIC', defaultMessage: 'VIC' } },
  { value: 'WA', label: { id: 'stateOptionsAustralia.WA', defaultMessage: 'WA' } },
  { value: 'ACT', label: { id: 'stateOptionsAustralia.ACT', defaultMessage: 'ACT' } },
  { value: 'NT', label: { id: 'stateOptionsAustralia.NT', defaultMessage: 'NT' } },
];

export const defaultStateOptions = [{ value: 'All', label: { id: 'stateOptions.All', defaultMessage: 'all' } }];

export const ENTIRE_BUILDING_DEAL_UNIT = 'Entire building';
